import { useTranslation } from 'react-i18next';
import { Checkbox, CheckboxChangeEvent, Divider, Form, FormInstance, List } from 'antd';

import { ConnectionSelectorPopconfirmContentContainer } from './ConnectionSelectorPopconfirmContent.styles';
import { useStores } from '@/hooks/use-stores';

const CONTAINER_HEIGHT = 250;

const ConnectionSelectorPopconfirmContent = ({
  options,
  form,
  fieldName,
}: {
  options: { value: string; label: string }[];
  form: FormInstance;
  fieldName: string;
}) => {
  const { t } = useTranslation();
  const { pidEditStore } = useStores();
  const formConnections = Form.useWatch(fieldName, { form, preserve: true }) || [];

  const onCheckboxChange =
    (value: string) =>
    ({ target: { checked } }: CheckboxChangeEvent) => {
      const newFormConnections = checked ? [...formConnections, value] : formConnections.filter(item => item !== value);
      form.setFieldValue(fieldName, newFormConnections);
      pidEditStore.setAssetConnectionsInEditIds(newFormConnections);
    };

  return (
    <ConnectionSelectorPopconfirmContentContainer>
      <Divider className="divider" />
      <span className="description">{t('connectionSelectorDescription')}</span>
      <Divider className="divider" />
      <div style={{ maxHeight: CONTAINER_HEIGHT, overflow: 'auto' }}>
        <List
          dataSource={options}
          renderItem={option => (
            <List.Item key={option.value}>
              <Checkbox
                value={option.value}
                checked={formConnections.includes(option.value)}
                onChange={onCheckboxChange(option.value)}
              >
                {option.label}
              </Checkbox>
            </List.Item>
          )}
        />
      </div>
    </ConnectionSelectorPopconfirmContentContainer>
  );
};

export default ConnectionSelectorPopconfirmContent;
